import { render, staticRenderFns } from "./component-games-list-grid.vue?vue&type=template&id=37646226&scoped=true"
import script from "./component-games-list-grid.vue?vue&type=script&lang=js"
export * from "./component-games-list-grid.vue?vue&type=script&lang=js"
import style0 from "./component-games-list-grid.vue?vue&type=style&index=0&id=37646226&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37646226",
  null
  
)

export default component.exports